import type { LimitOrderIdentity } from '@/utils/0x.types';

export const getLimitOrderIdentityKey = (identity: LimitOrderIdentity): string => {
  switch (identity.provider) {
    case '1inch':
      return `1inch:${identity.orderHash}`;
    case 'definitive':
      return `definitive:${identity.orderId}`;
    default: {
      const _exhaustive: never = identity;
      return _exhaustive;
    }
  }
};

export const getDefinitiveCancelMessage = (orderId: string): string =>
  `Definitive Flash v1 — Cancel Order\nOrder: ${orderId}`;
